import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import textStyles from "../../../../theme/foundations/generated/textStyles";
import { focusBorder } from "../../../../theme/foundations/static";
import colors from "../../../../theme/foundations/generated/colors";
const baseStyle = defineStyle(Object.assign(Object.assign({ _hover: {
        backgroundColor: "semantic.cta.secondaryHover",
        border: "1px solid",
        borderColor: `${colors.semantic.outline.focus} !important`,
    }, _focusVisible: Object.assign({ backgroundColor: "semantic.surface.1" }, focusBorder), _placeholder: {
        color: "semantic.icon.secondary",
    }, color: "semantic.text.primary", borderRadius: "none" }, textStyles.title.desktopCard), { marginInlineStart: "3 !important", "&:first-of-type": {
        marginInlineStart: "0 !important",
    }, border: "1px solid" }));
const sizes = {
    default: {
        width: "44px",
        height: "64px",
        px: "3",
        py: "4",
    },
};
const variants = {
    default: defineStyle({
        backgroundColor: "semantic.surface.1",
        borderColor: "semantic.border.primary",
    }),
    error: defineStyle({
        backgroundColor: "semantic.background.error",
        borderColor: "semantic.icon.error",
    }),
};
const pinInputTheme = defineStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        size: "default",
        variant: "default",
    },
});
export default pinInputTheme;
//# sourceMappingURL=PinInput.default.js.map